// extracted by mini-css-extract-plugin
module.exports = {"team":"Team_team__-zd0p","team-container":"Team_team-container__156EP"};